import { motion } from "framer-motion";
import { BookOpen, ClipboardCheck, MapPin, Calendar, Wallet, BarChart3 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useI18n } from "@/i18n/I18nProvider";
import { Link } from "react-router-dom";
import { useCmsSection } from "@/hooks/useCmsSection";

const icons = [ClipboardCheck, BookOpen, MapPin, Calendar, Wallet, BarChart3];

const ResourcesSection = () => {
  const { t, lang } = useI18n();
  const cms = useCmsSection("resources");

  return (
    <section className="py-10 bg-background">
      <div className="container">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <span className="text-secondary font-body font-semibold text-sm tracking-widest uppercase">{t.resources.tag}</span>
          <h2 className="text-3xl md:text-5xl font-display font-bold mt-3 text-foreground">
            {lang === 'ar' ? (cms.title_ar ? cms.title_ar : <>{t.resources.title1}<span className="text-gradient-warm">{t.resources.titleHighlight}</span></>) : (cms.title_fr ? cms.title_fr : <>{t.resources.title1}<span className="text-gradient-warm">{t.resources.titleHighlight}</span></>)}
          </h2>
          <p className="mt-1.5 text-muted-foreground font-body max-w-2xl mx-auto text-lg">
            {lang === 'ar' ? (cms.subtitle_ar || t.resources.description) : (cms.subtitle_fr || t.resources.description)}
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {t.resources.items.map((resource, i) => {
            const Icon = icons[i] || BookOpen;
            return (
              <motion.div
                key={i}
                className="group flex gap-5 p-6 rounded-xl bg-card shadow-card border border-border hover:shadow-elevated transition-all duration-300 hover:-translate-y-1"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
              >
                <div className="w-12 h-12 rounded-lg bg-secondary/10 flex items-center justify-center shrink-0 group-hover:bg-secondary group-hover:text-secondary-foreground transition-colors">
                  <Icon className="w-6 h-6 text-secondary group-hover:text-secondary-foreground transition-colors" />
                </div>
                <div>
                  <h3 className="text-base font-display font-semibold text-foreground mb-1.5">{resource.title}</h3>
                  <p className="text-sm text-muted-foreground font-body mb-3 leading-relaxed">{resource.description}</p>
                  <Button variant="link" className="p-0 h-auto text-primary font-body font-semibold text-sm" asChild>
                    <Link to={`/ressources/${resource.slug}`}>
                      {resource.cta} →
                    </Link>
                  </Button>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ResourcesSection;
